import React, { useEffect, useState } from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Button } from '@mui/material';
import '../../styles/timeSelection.css'; // Make sure this path is correct
import { API_ENDPOINTS } from '../../config/constants';
import axios from 'axios'; 

const TimeSelection = ({goBackCondn,portData,secondsLeft,setOrderId,onNext }) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const [options, setOptions] = useState([]);
  const [currency, setCurrency] = useState(''); // Default currency


  // const options = [
  //   { time: 15, price: 500 },
  //   { time: 40, price: 1000 },
  //   { time: 60, price: 1500  },
  //   { time: 90, price: 2000 },
  //   { time: 120, price: 2500  },
  // ];

  useEffect(() => {
    getTimePriceOptions();
  }, []);

  const handleSelect = (time) => {
    setSelectedTime(time);
  };

  const getTimePriceOptions = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(API_ENDPOINTS.GET_TIME_OPTIONS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log('Time Price Options:', response.data);
      const pricingList = Object.entries(response.data.pricingMaster).map(([time, price]) => ({
        time: Number(time),
        price:price
      }));
      setCurrency(response.data.currency); // Set currency from response or default to Yen
      setOptions(pricingList);
    } catch (error) {
      console.error('Error fetching time price options:', error);
    }
  };

  const handleBack = () => {
    goBackCondn(6);
  };

  const handleSubmit = async() => {
    const selected = options.find((opt) => opt.time === selectedTime);
    console.log('Selected option:', selected);
    if (selected) {
      try{
        if (secondsLeft > 0) {
          const response = await axios.post(API_ENDPOINTS.EXTRA_TIME_SELECTION, {
            portId: portData.id,
            currency: currency,
            time: selected.time,
            price: selected.price
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
          console.log('Response from EXTRA_TIME_SELECTION:', response.data);
          setOrderId(response.data.order.orderId);
          onNext({ time: selected.time, price: selected.price });
        }else {
          const response = await axios.post(API_ENDPOINTS.POST_TIME_SELECTION, {
            currency: currency,
            pricingData: {
              [selected.time]:selected.price
            }
          }, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
          console.log('Response from POST_TIME_SELECTION:', response.data); 
          onNext({ time: selected.time, price: selected.price });
          }
      }catch (error) {
        console.error('Error in onNext:', error);
      }
   }
  };

  return (
    <div className="time-selection-wrapper">
      <h3 className="time-selection-heading">Select the time of use</h3>

      {options.map((option) => {
        const isSelected = selectedTime === option.time;
        return (
          <div
            key={option.time}
            className={`time-option ${isSelected ? 'selected' : ''}`}
            onClick={() => handleSelect(option.time)}
          >
            <div className="time-option-left">
              <AccessTimeIcon style={{ color: isSelected ? '#fff' : '#000' }} />
              <span>{option.time} Minutes</span>
            </div>
            <div className="time-option-price">{`${option.price} ${currency}`}</div>
          </div>
        );
      })}

      <button
        onClick={handleSubmit}
        disabled={!selectedTime}
        className="time-selection-button"
      >
        Next
      </button>
      {secondsLeft >0 && <Button
        onClick={handleBack}
        variant="outlined"
          fullWidth
          sx={{
            width: '100%',
            maxWidth: '350px',
            height: '36px',
            borderRadius: '16px',
            color: '#261863',
            borderColor: '#261863',
            fontWeight: 'bold',
            textTransform: 'none',
          }}
      >
        Back
      </Button> }
    </div>
  );
};

export default TimeSelection;
